import { call, put, takeEvery } from "redux-saga/effects"

// Ecommerce Redux States
import {
  GET_REPORT_DETAIL,
  GET_REPORTS,
  GET_REPORT_COMMENTS,
  GET_AUTH_USER,
  UPDATE_REPORT,
  DELETE_REPORT,
} from "./actionTypes"

import {
  deleteReportFail,
  deleteReportSuccess,
  getAuthUsersFail,
  getAuthUsersSuccess,
  getReportDetailFail,
  getReportDetailSuccess,
  getReportsFail,
  getReportsSuccess,
  updateReportFail
} from "./actions"

//Include Both Helper File with needed methods
import {
  getReports,
  getReportDetail,
  getReportComents as getReportComentsApi, 
  updateReports,
  deleteReportsURL
} from "helpers/fakebackend_helper"

function* fetchReports(props) {
  try {
    const response = yield call(getReports, props.payload)
    
    yield put(getReportsSuccess(response))
  } catch (error) {
    yield put(getReportsFail(error))
  }
}

// function* updateReportsFun(props) {
//   try {
//     const response = yield call(updateReports, props.payload)
//     yield put(updateReportSuccess(response))
//   } catch (error) {
//     yield put(updateReportFail(error))
//   }
// }

// function* fetchAuthUsers() {
  
//   try {
//     const response = yield call(getAuthUsersResponse) 
//     yield put(getAuthUsersSuccess(response))
//   } catch (error) {
//     yield put(getAuthUsersFail(error))
//   }
// }

// function* fetchReportDetail({ reportId }) {
//   try {
//     const response = yield call(getReportDetail, reportId)
//     yield put(getReportDetailSuccess(response))
//   } catch (error) {
//     yield put(getReportDetailFail(error))
//   }
// }
// function* deleteReports(reportId ) {
//   try {
//     const response = yield call(deleteReportsURL, reportId.payload)
//     yield put(deleteReportSuccess(response))
//   } catch (error) {
//     yield put(deleteReportFail(error))
//   }
// }

function* reportsSaga() {
  yield takeEvery(GET_REPORTS, fetchReports)
  // yield takeEvery(GET_REPORT_DETAIL, fetchReportDetail)
  // yield takeEvery(UPDATE_REPORT, updateReportsFun)
  // yield takeEvery(DELETE_REPORT,deleteReports)
  // yield takeEvery(GET_AUTH_USER, fetchAuthUsers)
}

export default reportsSaga
